export const FLAG_REPORT_POST_SUCCESS = 'FLAG_REPORT_POST_SUCCESS';
